export default __webpack_public_path__ + "./images/cta-hero-bg-2.svg";